import type { ICategoryInsight, ICategoryInsightResponse } from "types/insights/category-insight";

export class CategoryInsights implements ICategoryInsight {
    constructor(categoriesInsight: ICategoryInsightResponse) {
        this.name = categoriesInsight.name;
        this.percentage = {
            lastYear: categoriesInsight.percentage.last_year * 100,
            thisYear: categoriesInsight.percentage.this_year * 100,
            yearlyChange: categoriesInsight.percentage.yearly_change * 100,
        };
    }

    name: string;
    percentage: {
        lastYear: number;
        thisYear: number;
        yearlyChange: number;
    };
}
